<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>Delete Account</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-img
          src="../../../assets/images/MimboLogo.png"
          class="logo"
        ></ion-img>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-list>
          <ion-item lines="none" class="ion-text-center" color="lightmimbo">
            <ion-text class="prompt"
              >Please enter your password to confirm the deletion of your
              account.
            </ion-text> </ion-item
          ><ion-item color="lightmimbo">
            <ion-input
              type="password"
              name="password"
              placeholder="Password"
              [(ngModel)]="password"
              required
            ></ion-input>
          </ion-item>
          <ion-item color="lightmimbo" lines="none">
            <ion-text
              color="primary"
              (click)="goToChangePassword()"
              class="link forgot-password"
              >Forgot Password?</ion-text
            ></ion-item
          >
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col
        class="ion-text-center"
        sizeMd="10"
        offsetMd="1"
        sizeXl="8"
        offsetXl="2"
      >
        <ion-button color="danger" (click)="confirmPasswordAndDelete()"
          ><ion-icon name="trash-outline" slot="start"></ion-icon> Delete
          Account</ion-button
        >
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2"> </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
